module.exports = __webpack_public_path__ + "static/media/category-thumb-toys.449276c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/category-thumb-toys.png
// module id = 2195
// module chunks = 0